module.exports = __webpack_public_path__ + "static/media/loading.c4483b59.svg";